export const ShareScreenIcon = ({ size = 18, strokeColor = "#7E57C2", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 130 96"
    fill="none"
    {...props}
  >
    <path
      d="M47 40L59 28L71 40"
      stroke="#7E57C2"
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59 52V28"
      stroke={strokeColor}
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M91 12H27C22.5817 12 19 15.5817 19 20V60C19 64.4183 22.5817 68 27 68H91C95.4183 68 99 64.4183 99 60V20C99 15.5817 95.4183 12 91 12Z"
      stroke={strokeColor}
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59 68V84"
      stroke={strokeColor}
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43 84H75"
      stroke={strokeColor}
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
